import {
  AccountRole,
  FilePayload,
  PhoneInputType,
  Statuses,
} from "./common.types";

export enum UserRoleToAssign {
  MANAGER = "MANAGER",
  OPERATION_SUPERVISOR = "OPERATION_SUPERVISOR",
  OPERATIONAL_STAFF = "OPERATIONAL_STAFF",
  SUPER_ADMIN = "SUPER_ADMIN",
  ADMIN = "ADMIN",
  PUBLIC_TRANSPORT_OPERATIONAL_USER = "PUBLIC_TRANSPORT_OPERATIONAL_USER",
}

export interface PhoneType extends PhoneInputType {
  fullNumber?: string;
}

export interface UserCreationInput
  extends Partial<FetchedUserProfile>,
    Partial<LocationInfo>,
    Partial<FetchedUserRole> {
  company?: string;
  department?: string;
  acceptTerms?: boolean;
  // subType here is the role assigned to user
  subType?: UserRoleToAssign;
}

export interface FetchedUserProfile {
  id?: string;
  orgID?: string;
  fullName?: string;
  idPassportNo?: string;
  idPassportType?: string;
  email?: string;
  pendingEmail?: string;
  mobileNo: PhoneType;
  street1?: string;
  street2?: string;
  city?: string;
  state?: string;
  postcode?: string;
  country?: string;
  fullAddress?: string;
  gender?: string;
  nric_passport?: Partial<FilePayload>;
}

export interface FetchedUserOrg {
  logisticProviderOrgID: string;
  name: string;
  orgType: string;
  id?: string;
}

export interface FetchedUserRole {
  orgID?: string;
  accountType?: string;
  approvalStatus?:
    | Statuses.APPROVED
    | Statuses.REJECTED
    | Statuses.UNAPPROVED
    | Statuses.PENDING;
  attachments?: FilePayload[];
  code?: string;
  department?: string;
  onlineStatus?: "ONLINE" | "OFFLINE";
  isDeactivated?: {
    tempDeletedOn?: string;
    tempDelete?: boolean;
    tempDeletedReason?: string | number;
  };
  status?: "ACTIVE" | "DEACTIVATED" | "PENDING_ACCOUNT";
  subType?: UserRoleToAssign;
  type?: AccountRole;
  bankType?: string;
  accountNo?: string;
  socsoNo?: string;
  epfNo?: string;
  incomeTax?: string;
  hrdfNo?: string;
  zakatNo?: string;
  emergencyContactName?: string;
  relationship?: string;
  emergencyContactNo?: PhoneType;
}

export interface LocationInfo {
  locationName?: string;
  location?: string;
}

export interface FetchedUserData extends LocationInfo {
  org?: FetchedUserOrg;
  profile?: FetchedUserProfile;
  userRole?: FetchedUserRole;
}

export enum UserProfileCategoriesTab {
  USER_DETAILS = "user_details",
  EMPLOYMENT_DETAILS = "employment_details",
  PAYMENT_DETAILS = "payment_details",
  EMERGENCY_CONTACTS = "emergency_contacts",
  ATTACHMENTS = "attachments",
}
